import { FunctionComponent, PropsWithChildren } from "react";
import classNames from "classnames";
import styles from "./Category.module.css";

type TProps = {
  innerRef?: any;
  handlerId?: string;
  opacity?: number;
  className?: string;
};

const Category: FunctionComponent<PropsWithChildren<TProps>> = (props) => (
  <li
    ref={props.innerRef}
    className={classNames(styles.category, props.className)}
    data-handler-id={props.handlerId}
    style={{ opacity: props.opacity }}
  >
    {props.children}
  </li>
);

export default Category;
